/**
 * Created by andrey on 04.11.2025
 */

const IslandDecorationComponentView = cc.Node.extend({
    ctor: function (islandDecoration, unitView) {
        this._super();

        this.islandDecoration = islandDecoration;
        this.logic = islandDecoration.logic;
        this.unitView = unitView;
        this.bundle = islandDecoration.bundle;

        unitView.sprite.setScale(0);

        const silent = cleverapps.bundleLoader.isLoaded(this.bundle.name);

        cleverapps.bundleLoader.loadBundle(this.bundle.name, {
            onSuccess: this.createListener(() => {
                this.createContent();

                if (!silent) {
                    this.showUp();
                }
            })
        });
    },

    checkTouchInside: function (touch) {
        const map = Map2d.currentMap;
        const cell = map.getMapView().getCellByTouch(touch);
        const unit = this.islandDecoration.unit;

        for (let dx = -1; dx <= 1; dx++) {
            for (let dy = -1; dy <= 1; dy++) {
                const cellUnit = map.getUnit(cell.x + dx, cell.y + dy);

                if (cellUnit && cellUnit.head === unit) {
                    return true;
                }
            }
        }

        return false;
    },

    createContent: function () {
        const styles = cleverapps.styles.IslandDecorationComponentView;

        const bg = this.bg = new cleverapps.Spine(this.bundle.jsons.island);
        bg.setAnimation(0, "animation", true);
        bg.setScale(Math.min(1, styles.width / bg.width, styles.height / bg.height));
        this.addChild(bg);

        if (!this.logic) {
            return;
        }

        let index = 0;
        this.logic.listStages().forEach((stage) => {
            stage.items.forEach((item) => {
                const slot = bg.getSlot(`slot_${item.name}`);
                if (slot) {
                    slot.setLocalZOrder(index);
                }
                index++;

                this.createItem(item, true);
            });
        });

        this.logic.on("onItemBought", (item) => this.createItem(item), this);
    },

    showUp: function () {
        const scale = this.bg.scale;
        this.bg.setScale(0);
        this.bg.runAction(new cc.ScaleTo(0.2, scale).easing(cc.easeBackOut()));
    },

    onDestruction: function () {
        if (!this.bg) {
            this.unitView.removeFromParent();
            return;
        }

        const scale = this.bg.scale;
        this.bg.runAction(new cc.Sequence(
            new cc.ScaleTo(0.2, scale * 0.3).easing(cc.easeBackIn()),
            new cc.CallFunc(() => this.unitView.removeFromParent())
        ));
    },

    createItem: function (item, silent) {
        const slot = this.bg.getSlot(`slot_${item.name}`);
        if (!slot || !this.logic.isItemBought(item)) {
            return;
        }

        let image;

        if (this.bundle.jsons[item.name]) {
            image = new cleverapps.Spine(this.bundle.jsons[item.name]);
            image.setAnimation(0, "idle", true);
        } else {
            image = new cc.Sprite(this.bundle.frames[item.name]);
        }

        image.setPosition(slot.width / 2, slot.height / 2);
        slot.addChild(image);

        if (!silent) {
            image.runAction(StandartAnimations.showUp(image, { flash: true }));
        }
    },

    cleanup: function () {
        this._super();

        if (!this._bundleDeleted) {
            this._bundleDeleted = true;
            cleverapps.bundleLoader.deleteBundle(this.bundle.name);
        }
    }
});

cleverapps.styles.IslandDecorationComponentView = {
    width: 1300,
    height: 1000
};